import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = a((e, c) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: c,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4107",
              width: 32,
              height: 15,
              x: 8,
              y: 17,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M39.25 30.02h-3.59c-3.64 0-5.19-1.41-5.19-4.72v-7.55c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7.55c0 4.13 2.25 6.22 6.69 6.22h3.59c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M18.28 17c-.41 0-.75.34-.75.75v7.55c0 3.31-1.55 4.72-5.19 4.72H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h3.59c4.44 0 6.69-2.09 6.69-6.22v-7.55c0-.41-.34-.75-.75-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4107)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-4.391-2.83h55.693v55.693H-4.391z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyNeckIcon";
export {
  t as AgencyNeckIcon,
  t as default
};
//# sourceMappingURL=index.js.map
